import ShowInsurancesInfoView from '../components/views/mx/creditoReal/ShowInsurancesInfoView';
import MarketingStepContainer from '../containers/mx/creditoReal/MarketingStepContainer';
import ValidateNIPBureauContainer from '../containers/mx/creditoReal/ValidateNIPBureauContainer';
import BureauQueryErrorContainer from '../containers/mx/creditoReal/BureauQueryErrorContainer';
import ShowFileImageContainer from '../containers/mx/creditoReal/ShowFileImageContainer';
import ValidationIdSuccessContainer from '../containers/mx/creditoReal/ValidationIdSuccessContainer';
import TurboCashOfferContainer from '../containers/mx/creditoReal/TurboCashOfferContainer';
import ErrorWithRetryView from '../../common/components/modal/ErrorWithRetryView';
import PayWarrantySuccessContainer from '../../pay-warranty/containers/mx/PayWarrantySuccessContainer';
import PayWarrantyRefusedContainer from '../../pay-warranty/containers/mx/PayWarrantyRefusedContainer';
import AssistantInformationContainer from '../containers/mx/AssistantInformationContainer';
import ValidationIdErrorContainer from '../containers/mx/creditoReal/ValidationIdErrorContainer';
import ValidationIdWaitingResponseContainer from '../containers/mx/creditoReal/ValidationIdWaitingResponseContainer';
import ValidationIdCurpErrorContainer from '../containers/mx/creditoReal/ValidationIdCurpErrorContainer';
import FileFailedUploadErrorContainer from '../containers/mx/creditoReal/FileFailedUploadErrorContainer';
import AssemblyCountryHelpContainer from '../containers/mx/creditoReal/AssemblyCountryHelpContainer';

export const MODAL_TYPE = {
    SHOW_INSURANCES_INFO_VIEW: 'SHOW_INSURANCES_INFO_VIEW',
    SHOW_VALIDATE_NIP_VIEW: 'SHOW_VALIDATE_NIP_VIEW',
    SHOW_VALIDATE_NIP_BUREAU_VIEW: 'SHOW_VALIDATE_NIP_BUREAU_VIEW',
    SHOW_BUREAU_QUERY_ERROR_VIEW: 'SHOW_BUREAU_QUERY_ERROR_VIEW',
    SHOW_FILE_FAILED_UPLOAD_VIEW: 'SHOW_FILE_FAILED_UPLOAD_VIEW',
    SHOW_MARKETING_STEP_VIEW: 'SHOW_MARKETING_STEP_VIEW',
    SHOW_FILE_IMG_VIEW: 'SHOW_FILE_IMG_VIEW',
    ERROR_WITH_RETRY_VIEW: 'ERROR_WITH_RETRY_VIEW',
    PAY_WARRANTY_SUCCESS_VIEW: 'PAY_WARRANTY_SUCCESS_VIEW',
    PAY_WARRANTY_REFUSED_VIEW: 'PAY_WARRANTY_REFUSED_VIEW',
    TURBO_CASH_OFFER_VIEW: 'TURBO_CASH_OFFER_VIEW',
    ASSISTANT_INFORMATION_VIEW: 'ASSISTANT_INFORMATION_VIEW',
    VALIDATION_ID_WAITING_RESPONSE: 'VALIDATION_ID_WAITING_RESPONSE',
    VALIDATION_ID_SUCCESS: 'VALIDATION_ID_SUCCESS',
    VALIDATION_ID_CURP_ERROR_CR: 'VALIDATION_ID_CURP_ERROR_CR',
    VALIDATION_ID_ERROR: 'VALIDATION_ID_ERROR',
    ASSEMBLY_COUNTRY_HELP_VIEW: 'ASSEMBLY_COUNTRY_HELP_VIEW',
};

export const MODAL_COMPONENTS = {
    SHOW_INSURANCES_INFO_VIEW: ShowInsurancesInfoView,
    SHOW_VALIDATE_NIP_BUREAU_VIEW: ValidateNIPBureauContainer,
    SHOW_BUREAU_QUERY_ERROR_VIEW: BureauQueryErrorContainer,
    SHOW_FILE_FAILED_UPLOAD_VIEW: FileFailedUploadErrorContainer,
    SHOW_MARKETING_STEP_VIEW: MarketingStepContainer,
    SHOW_FILE_IMG_VIEW: ShowFileImageContainer,
    ERROR_WITH_RETRY_VIEW: ErrorWithRetryView,
    PAY_WARRANTY_SUCCESS_VIEW: PayWarrantySuccessContainer,
    PAY_WARRANTY_REFUSED_VIEW: PayWarrantyRefusedContainer,
    TURBO_CASH_OFFER_VIEW: TurboCashOfferContainer,
    ASSISTANT_INFORMATION_VIEW: AssistantInformationContainer,
    VALIDATION_ID_WAITING_RESPONSE: ValidationIdWaitingResponseContainer,
    VALIDATION_ID_SUCCESS: ValidationIdSuccessContainer,
    VALIDATION_ID_CURP_ERROR_CR: ValidationIdCurpErrorContainer,
    VALIDATION_ID_ERROR: ValidationIdErrorContainer,
    ASSEMBLY_COUNTRY_HELP_VIEW: AssemblyCountryHelpContainer,
};
